module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', [(!_vm.isHcpView) ? _c('patient-view') : _vm._e(), _vm._v(" "), (_vm.isHcpView) ? _c('hcp-view') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f836fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard/Dashboard.vue
// module id = 3638
// module chunks = 1